var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useParams } from 'react-router-dom';
import { Box, LoadingBox, translate } from '@lucidlink/uicore';
import { useFilespaceById } from '#query-hooks';
import { filespaceRoutes } from '#services';
// TODO: https://lucidlink.atlassian.net/browse/LUCID-28686
// This route guard will not do anything if we have an error in the cache that uses the FilespacesKeyFactory.exact
// queryKey. This causes screens 'under' this route guard to stay in loading screen forever, basically not allowing the screens
// to show any error.
/**
 * This route guard is used to check if the filespace is in migrating state.
 * In order to not get into a redirection loop this guard should not be used
 * on the filespace dashboard page.
 */
export const IsMigratingRouteGuard = ({ children, }) => {
    _react_refresh_temp_2();
    const { filespaceId = '', workspaceId = '' } = useParams();
    const { query: { data: filespaceData }, } = useFilespaceById(workspaceId, filespaceId);
    if (!filespaceData) {
        return (_jsx(Box, { align: "center", isFullHeight: true, isFullWidth: true, justify: "center", children: _jsx(LoadingBox, { alt: translate('Loading filespace data'), "data-testid": "filespace-data", isFullHeight: true }) }));
    }
    if (filespaceData.isMigrating) {
        return (_jsx(Navigate, { to: filespaceRoutes.filespaceDashboard({
                filespaceId,
                workspaceId,
            }) }));
    }
    return children;
};
_react_refresh_temp_1 = IsMigratingRouteGuard;
$RefreshReg$(_react_refresh_temp_1, "IsMigratingRouteGuard");
_react_refresh_temp_2(IsMigratingRouteGuard, "IkVkxd7Lrd+trlrW7MlBzmopsEs=", false, () => [useParams, useFilespaceById]);
